module.exports = __webpack_public_path__ + "img/checkmark-outline.aee78dfa.svg";